import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExtractFromLoadService } from '../extract-from-load.service';
import { NgxSpinnerService } from "ngx-spinner";
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from "@angular/material/dialog";
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { InfoPopupComponent } from 'src/app/shared/components/info-popup/info-popup.component';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
import { TaskListPopupComponent } from 'src/app/shared/components/task-list-popup/task-list-popup.component';


@Component({
  selector: 'app-cloud-extract-landing',
  templateUrl: './cloud-extract-landing.component.html',
  styleUrls: ['./cloud-extract-landing.component.scss']
})
export class CloudExtractLandingComponent implements OnInit {
  extractFromCloudData: any = [];
  public dateFormat: any;
  public loader: boolean;
  public loadNewBtnDisable: boolean = false;
  dataSourceNew: any = new MatTableDataSource();
  filterSelectObj = [];
  filteredValue;
  filterValues = {};
  public searchText;
  displayedColumns: string[] = ['batch_key', 'batch_status', 'instance', 'requested_date', 'action'];

  public dataValue: [] = [];
  isTrainStopUrl: boolean;
  queryParams: any;
  refresh: boolean = false;
  emptyTable: boolean = false;
  pageIndex = 0;
  size = 5;
  p: any = 1;
  failedToFetchBatchKeys: boolean = false;
  tableData: any;
  cloudTaskLevelData: any = [];
  hideme: number;
  constructor(private celService: ExtractFromLoadService, public dialog: MatDialog, private notification: NotificationService,
    private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService, private _data: DataService) {
    this.filterSelectObj = [
      {
        name: 'Status',
        columnProp: 'batch_status',
        options: []
      }, {
        name: 'Cloud Instance',
        columnProp: 'instance',
        options: []
      }
    ];
    this.isTrainStopUrl = this.celService.getisTrainStopUrl();
    if (this.isTrainStopUrl) {
      // let obj={
      //   PROJ_ID: sessionStorage.getItem('projId'),
      //   USER_ID: sessionStorage.getItem('userId'),
      // }
      const obj = JSON.parse(sessionStorage.getItem('queryParams'));
      this.queryParams = obj;
    }
  }

  ngOnInit(): void {
    const prjid = this._data.projectID;
    if (prjid == null || prjid == undefined) {
      window.location.href = DconConfigAPI.redirectUri;
    } else {
      this.getReport();
      this.getExtractBatchkeys();
      this.getSelectedBatchTasks();
      this.dataSourceNew.filterPredicate = this.createFilter();
    }
  }

  getReport() {
    this.celService.getReportStatus = false;
    // this.maskPage()
    // this.celService.getReport().subscribe((res) => { 
    //   if(res.Result == "SUCCESS"){
    //     this.celService.getReportStatus = false;
    //   }
    //   else{
    //     this.celService.getReportStatus = false;
    //   }
    //   this.unMaskPage();
    // }, error => {
    //   this.unMaskPage();
    //   this.celService.getReportStatus = false;
    //   // this.notification.showError('Something went wrong!');
    // })
  }


  paginate(event: any) {
    this.pageIndex = event;
    this.tableData = this.dataSourceNew.filteredData.slice(event * this.size - this.size, event * this.size);
  }

  getExtractBatchkeys() {
    this.maskPage();
    this.loadNewBtnDisable = false;
    this.emptyTable = false;
    this.celService.getExtractBatchkeys().subscribe((res) => {
      if (res?.Status === "SUCCESS") {
        this.refresh = true;
        this.failedToFetchBatchKeys = false;
        this.extractFromCloudData = this.getDistinctWookBooks(res.Batch_Key);
        this.loader = false;
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.dataSourceNew.data = this.extractFromCloudData;
        this.tableData = this.dataSourceNew.data;
        this.filterSelectObj.filter((o) => {
          o.options = this.getFilterObject(this.extractFromCloudData, o.columnProp);
          o.options.splice(0, 0, "None");
        });
        res.Batch_Key.forEach((element) => {
          this.dateFormat = new Date(element.requested_date);
          this.dataValue = this.dateFormat.toLocaleDateString("en-US");
          if (element.batch_status === 'New') {
            this.loadNewBtnDisable = true;
          }
        });
      } else {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.failedToFetchBatchKeys = true;
      }
    }, (error) => {
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.failedToFetchBatchKeys = true;
      this.notification.showError('Something went wrong!');
    });
  }

  getDistinctWookBooks(res) {
    const distinctBatchKeys = res.reduce((obj, curr) => {
      let success_count = 0;
      let ErrorModule;
      let currModule;
      let success_path = '';
      const success_files = [];
      if (curr.output_file_path) {
        if ((curr.output_file_path).includes('\\OUT\\')) {
          success_count++;
          success_path = curr.output_file_path;
          success_files.push(curr.output_file_path);
          currModule = {
            "application": 'Success',
            "output_file_path": success_path,
            "success_count": success_count
          };
        } else {
          ErrorModule = {
            "application": "Error",
            "output_file_path": curr.output_file_path,
            "success_count": 0
          };
        }
      }
      const item = {
        "batch_key": curr.batch_key,
        "requested_date": curr.requested_date,
        "batch_status": curr.batch_status,
        "instance": curr.instance,
        "total_count": 0,
        module: []
      };
      if (!obj[curr.batch_key]) {
        obj[curr.batch_key] = item;
      }
      if (ErrorModule) {
        obj[curr.batch_key].total_count++;
        if (!obj[curr.batch_key].module.find((e) => e.application === 'Error')) {
          obj[curr.batch_key].module.push(ErrorModule);
        }
      } else if (currModule) {
        obj[curr.batch_key].total_count++;
        let module = obj[curr.batch_key].module.find((e) => e.application === 'Success');
        if (module) {
          module.success_count++;
        } else {
          obj[curr.batch_key].module.unshift(currModule);
        }
      }
      return obj;
    }, Object.create(null));
    return Object.values(distinctBatchKeys);
  }

  getDownloadDropdown(i) {
    this.hideme = i;
  }

  autoCloseForDropdownCars(event) {
    var target = event.target;
    if (!target.closest(".download-enhancement")) {
      this.hideme = null;
    }
  }

  filterChange(filter, event, indexVal) {
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.filterValues[filter.columnProp] = event.target.value.trim().toLowerCase();
    this.dataSourceNew.filter = JSON.stringify(this.filterValues);
    this.tableData = this.dataSourceNew.filteredData;

  }
  createFilter() {
    const filterFunction = function (data, filter): boolean {
      const searchTerms = JSON.parse(filter);
      let isFilterSet = false;
      for (const col in searchTerms) {
        if (searchTerms[col].toString() !== '' && searchTerms[col].toString().toLowerCase() !== 'none') {
          isFilterSet = true;
        } else {
          delete searchTerms[col];
        }
      }

      // console.log(searchTerms);

      const nameSearch = () => {
        let found = false;
        if (isFilterSet) {
          if (data.batch_status.toLowerCase() == searchTerms.batch_status && (!searchTerms.instance || searchTerms.instance == "undefined")) {
            found = true;
          } else if (data.batch_status.toLowerCase() == searchTerms.batch_status && data.instance.toLowerCase() == searchTerms.instance) {
            found = true;
          } else if ((!searchTerms.batch_status || searchTerms.batch_status == "undefined") && data.instance.toLowerCase() == searchTerms.instance) {
            found = true;
          }
          else if ((!searchTerms.batch_status || searchTerms.batch_status == "undefined") && (!searchTerms.instance || searchTerms.instance == "undefined")) {
            found = true;
          }
          return found;
        } else {
          return true;

        }
      };
      return nameSearch();
    };
    return filterFunction;
  }

  getFilterObject(fullObj, key) {
    const uniqChk = [];
    fullObj.filter((obj) => {
      if (!uniqChk.includes(obj[key])) {
        uniqChk.push(obj[key]);
      }
      return obj;
    });
    return uniqChk;
  }


  onClickBatchKey(item) {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
    const obj = {
      status: item.status,
      data: item
    };
    this.celService.batchKey = item.batch_key;
    this.celService.options = obj;

    if (item.batch_status === "New") {
      this.celService.getBatchKeyDetails(item.batch_key).subscribe(res => {
        this.celService.batchKeyDetails = this.prepareObjSet(res.Batch_Key_Details);
        this.celService.batchKeyDetailEdit = JSON.parse(JSON.stringify(this.celService.batchKeyDetails));
        this.celService.fromTable = true;
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.celService.tabval.next('extract');
        this.router.navigate(['extract'], { relativeTo: this.route });
      }, err => {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.notification.showError(err.message);
        // this.router.navigate(['select'], { relativeTo: this.route });
      });

    } else if (item.batch_status === "Cloud Extraction - Complete") {
      this.celService.fromTable = true;
      this.celService.extractBatchKey = item.batch_key;
      this.celService.instanceName = item.instance;
      sessionStorage.setItem("key", JSON.stringify([item.batch_key, "select"]));
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.router.navigate(['/cloud-load/load-to-cloud']);
    } else if (item.batch_status === 'Cloud Extraction - Process Submitted') {
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.alertPopUp("Task Status", this.celService.batchKey, 'Cloud Extraction in progress');
    }
    else {
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.alertPopUp("Task Status", this.celService.batchKey, item.batch_status);
    }
  }

  alertPopUp(type, batchkey, mess) {
    const dialogRef = this.dialog.open(InfoPopupComponent, {
      width: "917px",
      height: "220px",
      data: {
        type: type,
        mess: `Batch Key ${batchkey} <b>: ${mess}</b>`,
      },
    });
  }


  prepareObjSet(batchDetails) {
    const data = [];
    batchDetails.forEach(element => {
      const obj = JSON.parse(element.config_details);
      obj['saveStatus'] = false;
      if (obj.linedetail != null && obj.linedetail.length > 0) {
        obj.linedetail.forEach(elem => {
          if (elem.taskselected === 'Y') {
            obj['saveStatus'] = true;
          }
        });
      }
      data.push(obj);
    });
    console.log("getBatchKeyDetails -------  data", data);
    return data;
  }

  onExtractNewConfig() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
    this.celService.options = null;
    this.celService.batchKey = null;
    this.celService.fromTable = false;
    this.celService.configType = "extract";
    this.celService.tabval.next('select');
    this.router.navigate(['select'], { relativeTo: this.route });
  }

  filterResults() {
    if (!this.searchText) {
      this.dataSourceNew = [...this.extractFromCloudData];
    } else {
      this.dataSourceNew = this.extractFromCloudData.filter((item) => {
        return item.batch_key.toUpperCase().indexOf(this.searchText.toUpperCase()) > -1;
      });
    }
  }

  search(value: string): void {
    if (value == null || value == undefined) {
      return;
    }
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    const serchText = value.toUpperCase();
    this.dataSourceNew.data = this.extractFromCloudData.filter((val) => val.batch_key.toUpperCase().includes(serchText));
    this.tableData = this.dataSourceNew.filteredData;

    if (this.extractFromCloudData.some(item => item.batch_key === value) || value == "") {
      this.emptyTable = false;
      this.filterValues = {};
      this.searchText = undefined;
      this.filterSelectObj = [
        {
          name: 'Status',
          columnProp: 'batch_status',
          options: []
        }, {
          name: 'Cloud Instance',
          columnProp: 'instance',
          options: []
        }
      ];
      this.filterSelectObj.filter((o) => {
        o.options = this.getFilterObject(this.extractFromCloudData, o.columnProp);
        o.options.splice(0, 0, "None");
      });
      this.dataSourceNew = new MatTableDataSource();
      this.dataSourceNew.filterPredicate = this.createFilter();
      this.dataSourceNew.data = this.extractFromCloudData.filter((val) => val.batch_key.toUpperCase().includes(serchText));
      this.dataSourceNew.filter = JSON.stringify(this.filterValues);
      this.tableData = this.dataSourceNew.filteredData;
    } else {
      this.emptyTable = true;
    }
  }

  onRefresh() {
    this.refresh = false;
    this.pageIndex = 0;
    this.size = 5;
    this.p = 1;
    this.filterValues = {};
    this.searchText = undefined;
    this.maskPage();
    this.filterSelectObj = [
      {
        name: 'Status',
        columnProp: 'batch_status',
        options: []
      }, {
        name: 'Cloud Instance',
        columnProp: 'instance',
        options: []
      }
    ];
    this.dataSourceNew = new MatTableDataSource();
    this.dataSourceNew.filterPredicate = this.createFilter();
    this.getExtractBatchkeys();
    this.getSelectedBatchTasks();
  }

  maskPage() {
    this._data.apiCallInProgress = true;
    document.getElementById("overlay").style.display = "block";
  }

  unMaskPage() {
    this._data.apiCallInProgress = false;
    document.getElementById("overlay").style.display = "none";
  }

  downloadFiles(rowData, batch_key, instance, downloadInFile=false) {
    let pathSplitArray: any;
    let body: any;
    this._data.apiCallInProgress = true;

    document.getElementById("overlay").style.display = "block";
    if (rowData.output_file_path != null) {
      pathSplitArray = rowData.output_file_path.split(batch_key);
      body = {
        "filePath": pathSplitArray[0],
        "batchKey": batch_key
      };
    } else {
      body = {
        "filePath": rowData.output_file_path,
        "batchKey": batch_key
      };
    }
    if(downloadInFile){
      let path=body["filePath"]
      const updatedPath = path.replace('\\OUT\\', '\\IN\\');
      body["filePath"]=updatedPath
    }
    this.celService.downloadFilesFromTable(body).subscribe(res => {
      if (res.byteLength === 1176) {
        this.notification.showError("Failed to download the file");
      } else {
        this.writeContents(res, `${batch_key}_${instance}.zip`);
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";

      }
    },
      error => {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
        this.notification.showError("Failed to download the file");
      });

  }

  writeContents(content, fileName) {  //contentType
    const a = document.createElement('a');
    const file = new Blob([content]); //, { type: contentType }
    a.href = URL.createObjectURL(file);
    a.download = fileName;
    a.click();
  }

  searchOnInput(event) {
    if (event == null || event == undefined || event == '') {
      this.search('');
    }
  }

  getSelectedBatchTasks() {
    this.maskPage();
    this.celService.getSelectedBatchTasks().subscribe((res) => {
      if (res?.Result === "SUCCESS" && res.Config_Batchkey_Details !== undefined) {
        this.cloudTaskLevelData = this.getDistinctBatchKeys(res.Config_Batchkey_Details);//res.Batch_key_details;
        // console.log("distinct batchkey", this.cloudTaskLevelData)

        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";

      } else {
        this._data.apiCallInProgress = false;
        document.getElementById("overlay").style.display = "none";
      }

    }, error => {
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
      this.notification.showError('Something went wrong!');
    })
  }

  getDistinctBatchKeys(res) {
    const distinctBatchKeys = res.reduce((obj, curr) => {
      const item = {
        "batch_key": curr.batch_key,
        module: []
      };
      const task_list = [curr.task_name];
      const currModule = {
        "application": curr.application,
        "task_list": task_list,
      };
      if (!obj[curr.batch_key]) {
        obj[curr.batch_key] = item;
        obj[curr.batch_key].module.push(currModule);
      } else {
        //same batch && new module
        if (!obj[curr.batch_key].module
          .find(e => e.application === curr.application)) {
          obj[curr.batch_key].module.push(currModule);
        } else {
          //same batch && same module
          obj[curr.batch_key].module.map(e => {
            if (e.application === curr.application) {
              e.task_list.push(curr.task_name);
            }
          });
        }
      }
      return obj;
    }, Object.create(null));
    return Object.values(distinctBatchKeys);
  }


  tasklistPopup(batchkey) {
    const module = this.cloudTaskLevelData.filter(e => e.batch_key === batchkey);
    const dialogRef = this.dialog.open(TaskListPopupComponent, {
      width: "795px",
      height: "470px",
      data: {
        moduleData: { batchkey: batchkey, module: module },
      },
    });
  }

}
